<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const goNextPage = () => {
    router.push({ name:'cloudCounterVideoOperationVerify' });
}

const getChineseDigits = (num) => {
    if (num >= 0 && num < 10) {
        return ['一', '二', '三', '四', '五', '六', '七', '八', '九'][num];
    }
    return '';
};


// #region 申請保單
const policyInfo = ref(null);

// 串接...
policyInfo.value = { key: '1068302189-00', value: 'XWS5 富邦人壽新平準終身壽險' };
// #endregion

// #region 生存保險金受益人
const beneficiaries = ref(null);

// 串接...
beneficiaries.value = [
    {
        boxList: [
            {
                title: '林大富',
                list: [
                    { key: '身分證號碼', value: 'A1*****789' },
                    { key: '與被保險人的關係', value: '子女' },
                    { key: '出生日期', value: '86/05/**' },
                    { key: '國籍', value: '中華民國' },
                    { key: '受益人匯款帳號', value: ' 0120000 台北富邦商業銀行台北分行<br>0000123*****67' },
                    { key: '受益人分配比例', value: '50%' }
                ]
            },
        ]
    },
    {
        boxList: [
            {
                title: '林小邦',
                list: [
                    { key: '身分證號碼', value: 'A1*****789' },
                    { key: '與被保險人的關係', value: '子女' },
                    { key: '出生日期', value: '86/05/**' },
                    { key: '國籍', value: '中華民國' },
                    { key: '受益人匯款帳號', value: ' 0120000 台北富邦商業銀行台北分行<br>0000123*****67' },
                    { key: '受益人分配比例', value: '50%' }
                ]
            },
        ]
    },
];
// #endregion

// #region 滿期保險金
const maturedInfo = ref(null);

// 串接...
maturedInfo.value = {
    boxList: [
        {
            title: '林大富',
            list: [
                { key: '身分證號碼', value: 'A1*****789' },
                { key: '與被保險人的關係', value: '子女' },
                { key: '出生日期', value: '86/05/**' },
                { key: '國籍', value: '中華民國' },
                { key: '受益人匯款帳號', value: '0120000 台北富邦商業銀行台北分行<br>0000123*****67' },
                { key: '受益人分配比例', value: '50%' }
            ]
        },
    ]
};
// #endregion

// #region 死亡保險金
const deathBenefitInfo = ref(null);
deathBenefitInfo.value = {
    boxList: [
        {
            title: '林大富',
            list: [
                { key: '身分證號碼', value: 'A1*****789' },
                { key: '與被保險人的關係', value: '子女' },
                { key: '出生日期', value: '86/05/**' },
                { key: '國籍', value: '中華民國' },
                { key: '受益人匯款帳號', value: ' 0120000 台北富邦商業銀行台北分行<br>0000123*****67' },
                { key: '受益人分配比例', value: '50%' }
            ]
        },
    ]
};
// #endregion

const infoBoxVisble = ref(false);
const okHandel = () => {

};

</script>

<template>

    <!-- 要保人變更 -->
    <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="1"></Process>
        </div>

        <div class="pb-6">
            <h2 class="pb-3 text-2xl font-bold">
                申請紀錄
            </h2>
            <CaseBox :caseBox="{
        boxList: [
            {
                list: [
                    { key: '申請日期', value: '113/06/15' },
                    { key: '申請項目', value: '受益人變更' },
                    { key: '受理案號', value: '114-WBP-0023902' },
                    { key: '視訊時間', value: '113/07/02 10:00~11:00' },
                    { key: '處理狀態', value: '待視訊確認中' }
                ]
            }
        ]
    }" />
        </div>

        <h2 class="pb-3 text-2xl font-bold">
            申請明細
        </h2>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                申請保單
            </h3>
            <CaseBox :caseBox="policyInfo" />
        </div>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                生存保險金受益人
            </h3>
            <div :class="{ 'pt-2': i !== 0 }" v-for="(caseBox, i) in beneficiaries" :key="i">
                <h4 class="pb-4 text-lg font-bold">
                    第{{ getChineseDigits(i) }}順位
                </h4>
                <CaseBox :caseBox="caseBox" />
            </div>
        </div>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                滿期保險金
            </h3>
            <CaseBox :caseBox="maturedInfo" />

        </div>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                身故保險金
            </h3>
            <CaseBox :caseBox="deathBenefitInfo" />

        </div>

        <div class="text-center">
            <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true }">取消預約申請</button>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">開始視訊</button>
        </template>

    </Layout>

    <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？" type="confirm"
        :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />

</template>

<style scoped></style>
